import { Injectable } from '@angular/core';
import { Keybinding, ViewModel } from '@farris/devkit'
import * as Mousetrap from 'mousetrap';
import { Observable } from 'rxjs';

const enum CharCode {

  Digit0 = 48,
  Digit1 = 49,
  Digit2 = 50,
  Digit3 = 51,
  Digit4 = 52,
  Digit5 = 53,
  Digit6 = 54,
  Digit7 = 55,
  Digit8 = 56,
  Digit9 = 57,

  A = 65,
  B = 66,
  C = 67,
  D = 68,
  E = 69,
  F = 70,
  G = 71,
  H = 72,
  I = 73,
  J = 74,
  K = 75,
  L = 76,
  M = 77,
  N = 78,
  O = 79,
  P = 80,
  Q = 81,
  R = 82,
  S = 83,
  T = 84,
  U = 85,
  V = 86,
  W = 87,
  X = 88,
  Y = 89,
  Z = 90,

  a = 97,
  b = 98,
  c = 99,
  d = 100,
  e = 101,
  f = 102,
  g = 103,
  h = 104,
  i = 105,
  j = 106,
  k = 107,
  l = 108,
  m = 109,
  n = 110,
  o = 111,
  p = 112,
  q = 113,
  r = 114,
  s = 115,
  t = 116,
  u = 117,
  v = 118,
  w = 119,
  x = 120,
  y = 121,
  z = 122
}

/**
 * å¿«æ·é®æå¡
 * @scope FormModule
 */
@Injectable()
export class KeybindingService {
  private keyMap: Map<String, () => Observable<any>>;
  private bindingProvider: Mousetrap;
  private ready: boolean;

  constructor() {
    this.keyMap = new Map<String, () => Observable<any>>();
    this.bindingProvider = Mousetrap.default;
    this.ready = true;
  }

  /**
   * å¯¹è§å¾æ¨¡åè®¾ç½®çå¿«æ·é®è¿è¡ç»å®å¤ç
   * @param viewModel è§å¾æ¨¡å
   */
  public bind(viewModel: ViewModel) {
    viewModel.keybindingMap.forEach((keyBinding, method) => {
      this.register(keyBinding, () => {
        return viewModel[method]();
      });
    });
  }

	/**
	 * æ³¨åå¿«æ·é®
	 * @param binding é®çç»å®ä¿¡æ¯
	 * @param handler ååºäºä»¶
	 */
  public register(binding: Keybinding, handler: () => Observable<any>) {
    var combo = this._getCombo(binding);
    if (combo) {
      this.keyMap.set(combo, handler);
      if (binding.ctrlKey && binding.altKey && !binding.shiftKey) {
        // å®éåç°ï¼ctrl+altç»åï¼åªè½è§¦åkeyupäºä»¶
        this.bindingProvider.bind(combo, this._dispatch.bind(this), 'keyup');
      } else {
        this.bindingProvider.bind(combo, this._dispatch.bind(this));
      }
    }
  }

  /**
   * åæ¶å¿«æ·é®æ³¨å
   * @param binding é®çç»å®ä¿¡æ¯ 
   */
  public unregister(binding: Keybinding) {
    var combo = this._getCombo(binding);
    if (combo) {
      this.keyMap.delete(combo);
      this.bindingProvider.unbind(combo);
    }
  }

  private _dispatch(e: KeyboardEvent): boolean {
    if (e.repeat) return false;
    if (this.ready) {
      var combo = this._getCombo(e);
      if (combo && this.keyMap.has(combo)) {
        this.ready = false;
        this.keyMap.get(combo)().subscribe(() => {
          this.ready = true;
        }, (error) => {
          this.ready = true;
        }, () => {
          this.ready = true;
        });
      }
    }
    return false;
  }

	/**
	 * è¿åctrl+shift+alt+aå½¢å¼çç»åå­ç¬¦ä¸²ï¼å¨é¨ä¸ºå°å
	 * @param keyInfo 
	 */
  private _getCombo(keyInfo: Keybinding | KeyboardEvent): String | null {
    var key = keyInfo.key.toLowerCase();
    if (key.length != 1 || key.charCodeAt(0) < CharCode.a || key.charCodeAt(0) > CharCode.z) {
      console.warn("å¿«æ·é®å­æ¯å½¢å¼ä¸ºa-z");
      return null;
    }
    var combo = (keyInfo.ctrlKey ? 'ctrl+' : '')
      + (keyInfo.shiftKey ? 'shift+' : '')
      + (keyInfo.altKey ? 'alt+' : '')
      + (keyInfo.metaKey ? 'meta+' : '')
      + key;

    if (combo.length == 1) {
      console.warn("å¿«æ·é®è³å°åå«ä¸ä¸ªModifieré®");
      return null;
    }

    return combo;
  }
}